import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/LoginForm';

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/');
  }, [user]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        <LoginForm onSuccess={() => navigate('/')} recaptchaContainerId="recaptcha-container-page" />
      </div>
    </div>
  );
}
